import { gettext } from '@eventbrite/i18n';
import { Badge, Typography } from '@eventbrite/marmalade';

import React from 'react';

export const AnnualDiscountBadge = () => {
    return (
        <Badge
            variant="custom"
            bordered={false}
            style={{ backgroundColor: '#EAEEFD' }}
        >
            <Typography as="p" color="neutral-900" variant="body-sm-bold">
                {gettext('Save 20%').toString()}
            </Typography>
        </Badge>
    );
};
